export default __webpack_public_path__ + "static/media/iva_s.ff82c522.jpg";